const categories = [
  'Course & enrolment',
  'Campus life & transport',
  'Learning & research',
  'Fees & scholarships',
  'Career & opportunities',
  'Help & support',
];

export default categories;
